'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

var _actions2 = require('../User/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hoaPortalLogout(portalState) {
  return (0, _extends3.default)({}, portalState, {
    portal: undefined,
    fetched: false
  });
}

function hoaPortalSet(portalState, _ref) {
  var portal = _ref.portal;

  return (0, _extends3.default)({}, portalState, {
    portal: portal,
    fetched: true
  });
}

function hoaPortalsSet(portalState, _ref2) {
  var portals = _ref2.portals;

  return (0, _extends3.default)({}, portalState, {
    portals: portals,
    fetchedPortals: true
  });
}

function hoaPortalUnset(portalState) {
  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.removeItem('hoa_portal');
  }

  return (0, _extends3.default)({}, portalState, {
    portal: undefined,
    fetched: false
  });
}

var reducer = (0, _createReducer3.default)({
  portal: undefined,
  portals: undefined,
  fetched: false
}, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _actions2.USER_LOGOUT, hoaPortalLogout), (0, _defineProperty3.default)(_createReducer, _actions.HOAPORTAL_SET, hoaPortalSet), (0, _defineProperty3.default)(_createReducer, _actions.HOAPORTALS_SET, hoaPortalsSet), (0, _defineProperty3.default)(_createReducer, _actions.HOAPORTAL_UNSET, hoaPortalUnset), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/HoaPortal/reducer.js
// module id = 826
// module chunks = 0